import axios, { AxiosError } from "axios";
import { API_GATEWAY, PR_DEP } from "../config/globalVariables";
import header from "../config/requestHeader";
import { handleAxiosError } from "../helpers/handleAxiosError";

export const menuClient = axios.create({
  baseURL: `${API_GATEWAY + PR_DEP}/menu`,
  headers: header,
});

menuClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error instanceof AxiosError && error.isAxiosError && error.response) {
      handleAxiosError(error);
    }
    throw error;
  }
);